import { gql } from '@apollo/client'

export const RESEND_MEETING_INVITATIONS = gql`
  mutation ResendMeetingInvitations($meetingId: String!, $type: String!) {
    resendMeetingInvitations(meetingId: $meetingId, type: $type)
  }
`
